const VehicleRecordTypeEnum = {
  Joint: 1,
  Consignment: 2,
  Single: 3,
};

export default VehicleRecordTypeEnum;
